import React from 'react';
import classNames from 'classnames';

import css from './IconSecurity.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "security" icon
 */
const IconSecurity = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="12"
      height="12"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 22.943C3.533 18.32 2.498 12.026 3.16 4.723l.08-.869.871-.042c3.31-.166 5.668-.934 7.21-2.35L12 .838l.68.624c1.54 1.416 3.9 2.184 7.21 2.35l.87.042.08.869c.666 7.34-.407 13.61-8.84 18.22zM4.16 4.811c-.543 5.988-.04 12.694 7.838 16.993 7.88-4.3 8.39-11.001 7.845-16.99-3.553-.178-6.12-1.036-7.84-2.616-1.72 1.58-4.29 2.435-7.842 2.613z" />
    </svg>
  );
};

export default IconSecurity;
